import { render, staticRenderFns } from "./InventoryManagementForm.vue?vue&type=template&id=0500daac"
import script from "./InventoryManagementForm.vue?vue&type=script&lang=js"
export * from "./InventoryManagementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports